(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SmsPatternDialogController', SmsPatternDialogController);

    SmsPatternDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Company', 'SettingInfo', 'AgreementInfo', 'LocationInfo', 'MetaTag', 'SmsPattern', 'Marketplace'];

    function SmsPatternDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Company, SettingInfo, AgreementInfo, LocationInfo, MetaTag, SmsPattern, Marketplace) {
        var vm = this;

        vm.smsPattern = entity;
        vm.clear = clear;
        vm.save = save;
        vm.isTemplateValid = isTemplateValid;

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            if (vm.smsPattern.id !== null) {
                SmsPattern.updateItem().update({
                    id: vm.smsPattern.id,
                    template: vm.smsPattern.notificationTemplate.template,
                    approvalStatus: vm.smsPattern.approveStatus,
                    approveResult: vm.smsPattern.approveResult,

                }, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function isTemplateValid() {
            if (!vm.smsPattern.notificationTemplate.template) {
                return false;
            }

            return vm.smsPattern.notificationTemplate.template.includes("لغو11");
        }

    }
})();